<template>
  <div
    class="div"
    :style="{
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px',
    }"
  >
    <h1 class="h1">【{{ updates.title }}】</h1>
    <a-button class="button" type="primary" @click="update">更新</a-button>

    <a-row>
      <span>内容</span>
    </a-row>
    <a-divider />
    <a-row class="icon">
      <a-icon type="snippets" />
      <a-icon type="font-colors" />
      <a-icon type="bold" />
      <a-icon type="italic" />
    </a-row>
    <a-row> 用户协议： </a-row>
    <a-row class="content">
      <!-- <a-textarea
        v-model="updates.content"
        placeholder="Basic usage"
        :rows="4"
      /> -->
      <quill-editor
        v-model="updates.content"
        ref="myQuillEditor"
        :options="editorOption"
        @blur="onEditorBlur($event)"
        @focus="onEditorFocus($event)"
        @change="onEditorChange($event)"
      >
      </quill-editor>
    </a-row>
  </div>
</template>

<script>
import { userDetails, updateuserDetails } from "@/api/homeApi.js";
import { message } from "ant-design-vue";
// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
  ["blockquote", "code-block"], // 引用  代码块
  [{ header: 1 }, { header: 2 }], // 1、2 级标题
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
  [{ script: "sub" }, { script: "super" }], // 上标/下标
  [{ indent: "-1" }, { indent: "+1" }], // 缩进
  // [{'direction': 'rtl'}],                         // 文本方向
  [{ size: ["small", false, "large", "huge"] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  [{ font: [] }], // 字体种类
  [{ align: [] }], // 对齐方式
  ["clean"], // 清除文本格式
  ["link", "image", "video"], // 链接、图片、视频
];
export default {
  name: "ProtocolRules",
  data() {
    return {
      updates: {
        objId: "",
        title: "用户协议",
        content: "",
        type: 1201,
      },
    };
  },
  mounted() {
    this.getUserDetails();
  },
  methods: {
    getUserDetails() {
      userDetails(1201).then((res) => {
        this.updates.title = res.data.title;
        this.updates.content = res.data.content;
        this.updates.objId = res.data.objId;
      });
    },
    update() {
      updateuserDetails(this.updates).then((res) => {
        this.getUserDetails();
        message.success("更新成功");
      });
    },
  },
};
</script>

<style scoped>
.div {
  height: 80vh;
}
.content {
  margin-top: 20px;
  margin-left: 20px;
}
.button {
  position: relative;
  left: 500px;
  bottom: 50px;
  width: 100px;
  height: 40px;
}
.h1 {
  font-size: 28px;
}
.icon {
  height: 50px;
}
.icon a-icon {
  height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/ProtocolRules.vue